import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Fetchable from '~/commons/components/util/Fetchable';
import env from '~/commons/config/env';
import Page from '../../layout/Page';
import Board from '../../layout/Board';

const PageStageDifficulties = () => {
  const { stage: url } = useParams();
  const { t } = useTranslation();

  return (
    <Page>
      <Fetchable
        req={{
          url: '/api/stages',
          params: { filter: { url: `/${url}` } },
        }}
      >
        {({ rows: stages }) => {
          const difficulties = env.difficulties.filter((d) => (
            stages.find((s) => s.difficulty === d)
          ));

          return (
            <div className="container text-center">
              <Board fillScreen>
                <h1 className="fw-bold my-3">
                  {t('pg.game.difficulty')}
                </h1>
                <img
                  className="mb-4 mt-3"
                  src="/assets/img/scale.png"
                  alt=""
                  style={{
                    maxWidth: '250px',
                  }}
                />
                <div className="row g-4 justify-content-center">
                  {difficulties.map((d) => (
                    <Link
                      key={d}
                      className="col-12 col-md-auto"
                      to={`${d}`}
                    >
                      <div
                        className="ratio ratio-1x1 mx-auto"
                        style={{ width: '150px' }}
                      >
                        <div
                          className={`
                          border border-primary border-3 rounded-3
                          d-flex flex-column
                        `}
                        >
                          <img
                            className="m-auto"
                            src="/assets/img/weight.png"
                            alt="difficulty"
                            style={{
                              width: ({
                                low: '24%',
                                mid: '30%',
                                high: '36%',
                              })[d],
                            }}
                          />
                          <h5 className="fw-bold mt-2 mb-3">{t(d)}</h5>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </Board>
            </div>
          );
        }}
      </Fetchable>
    </Page>
  );
};

export default PageStageDifficulties;
